import apiClient from '@/lib/api-client';

export interface GeoResponse {
  country: string | null;
  currency: string;
}

/**
 * Detect the user's country and currency based on their IP (server-side via Cloudflare headers).
 * Falls back gracefully if the endpoint is unreachable.
 */
export async function fetchGeo(): Promise<GeoResponse> {
  const { data } = await apiClient.get<{ success: boolean; data: GeoResponse }>('/v1/geo');
  return data.data;
}
